export const RETURN_TO_INCOME_TAX_SUMMARY_TEXT =
  'There is no component ID result for given context data. Returning to Income Tax Summary screen...';
